import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/accounts_2024/name.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/achievements_2025/hero.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/halloween_2024/opengraph-image.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/holidays_2023/holiday_theme_banner.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/masters_2024/three_dice.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/music_2024/opengraph-image.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/panda_2024/panda.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/opengraph-image.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/solved/hero.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/timing_2024/timer.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/vision_2023/renaissance.png");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterProfileLink"] */ "/app/apps/royalur/src/components/layout/FooterProfileLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/royalur/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/backgrounds/home.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/discord.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/reddit.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/rss.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/logo_text_only.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["CookiePreferencesButton"] */ "/app/packages/web_components/src/cookie/CookiePreferencesButton.tsx");
